module.exports = "mat-divider {\n    margin-top: 20px;\n    margin-bottom: 15px;\n}\n\n#input {\n    color: black\n}"